import plusnew, { component } from "@plusnew/core";

export default component(__dirname, () => <span>Loading...</span>);
